var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 13.004"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.969 1.549a6.667 6.667 0 0 1-1.883.517A3.305 3.305 0 0 0 15.528.251a6.775 6.775 0 0 1-2.085.789 3.279 3.279 0 0 0-5.674 2.238 3.356 3.356 0 0 0 .085.749A9.289 9.289 0 0 1 1.094.61 3.214 3.214 0 0 0 .65 2.26a3.28 3.28 0 0 0 1.458 2.73 3.269 3.269 0 0 1-1.485-.41v.041a3.282 3.282 0 0 0 2.631 3.218 3.31 3.31 0 0 1-1.475.057 3.291 3.291 0 0 0 3.069 2.278 6.578 6.578 0 0 1-4.068 1.4 6.962 6.962 0 0 1-.78-.043 9.33 9.33 0 0 0 5.038 1.473 9.265 9.265 0 0 0 9.332-9.323c0-.139 0-.28-.01-.42A6.624 6.624 0 0 0 16 1.562l-.031-.013Z"
  })));
};

export default SvgTwitter;